// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyBiPayorResult {
    'agentName'?: string | null;
    'id'?: string | null;
    'name'?: string | null;
    'phone'?: string | null;
    'referenceId'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyBiPayorResult>> = [
        {
            "name":     "agentName",
            "baseName": "agentName",
            "type":     "string"
        },
        {
            "name":     "id",
            "baseName": "id",
            "type":     "string"
        },
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "string"
        },
        {
            "name":     "referenceId",
            "baseName": "referenceId",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyBiPayorResult.attributeTypeMap;
    }
}
